/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RunZeroMeasurementRequestDto
 */
export interface RunZeroMeasurementRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RunZeroMeasurementRequestDto
     */
    parameterCombinationHash?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RunZeroMeasurementRequestDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RunZeroMeasurementRequestDto
     */
    $type?: RunZeroMeasurementRequestDtoTypeEnum;
}


/**
 * @export
 */
export const RunZeroMeasurementRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMeasurementComponentDtoRunZeroMeasurementRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MeasurementComponent.Dto.RunZeroMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RunZeroMeasurementRequestDtoTypeEnum = typeof RunZeroMeasurementRequestDtoTypeEnum[keyof typeof RunZeroMeasurementRequestDtoTypeEnum];



/**
 * Check if a given object implements the RunZeroMeasurementRequestDto interface.
 */
export function instanceOfRunZeroMeasurementRequestDto(value?: unknown): value is RunZeroMeasurementRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RunZeroMeasurementRequestDtoTypeEnum)[0];
}

export function RunZeroMeasurementRequestDtoFromJSON(json: any): RunZeroMeasurementRequestDto {
    return RunZeroMeasurementRequestDtoFromJSONTyped(json, false);
}

export function RunZeroMeasurementRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunZeroMeasurementRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parameterCombinationHash': json['parameterCombinationHash'] == null ? undefined : json['parameterCombinationHash'],
        'supportSystemEntityIds': json['supportSystemEntityIds'] == null ? undefined : json['supportSystemEntityIds'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function RunZeroMeasurementRequestDtoToJSON(value?: RunZeroMeasurementRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'parameterCombinationHash': value['parameterCombinationHash'],
        'supportSystemEntityIds': value['supportSystemEntityIds'],
        '$type': value['$type'],
    });
}

